import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AdminGuard } from './guards/admin/admin.guard';
import { DepotGuard } from './guards/depot/depot.guard';
import { HouseholdGuard } from './guards/household/household.guard';
import { MrBinGuard } from './guards/mr-bin/mr-bin.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./pages/about/about.module').then((m) => m.AboutPageModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./pages/register/register.module').then(
        (m) => m.RegisterPageModule
      ),
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./pages/contact/contact.module').then((m) => m.ContactPageModule),
  },
  {
    path: 'mr-bin-home',
    loadChildren: () =>
      import('./pages/users/mr-bin/mr-bin-home/mr-bin-home.module').then(
        (m) => m.MrBinHomePageModule
      ),
    canActivate: [MrBinGuard],
  },
  {
    path: 'mr-bin-view-houses',
    loadChildren: () =>
      import(
        './pages/users/mr-bin/mr-bin-view-houses/mr-bin-view-houses.module'
      ).then((m) => m.MrBinViewHousesPageModule),
    canActivate: [MrBinGuard],
  },
  {
    path: 'mr-bin-update',
    loadChildren: () =>
      import('./pages/users/mr-bin/mr-bin-update/mr-bin-update.module').then(
        (m) => m.MrBinUpdatePageModule
      ),
    canActivate: [MrBinGuard],
  },
  {
    path: 'mr-bin-depots',
    loadChildren: () =>
      import('./pages/users/mr-bin/mr-bin-depots/mr-bin-depots.module').then(
        (m) => m.MrBinDepotsPageModule
      ),
    canActivate: [MrBinGuard],
  },
  {
    path: 'mr-bin-history',
    loadChildren: () =>
      import('./pages/users/mr-bin/mr-bin-history/mr-bin-history.module').then(
        (m) => m.MrBinHistoryPageModule
      ),
    canActivate: [MrBinGuard],
  },
  {
    path: 'household-home',
    loadChildren: () =>
      import(
        './pages/users/household/household-home/household-home.module'
      ).then((m) => m.HouseholdHomePageModule),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'household-edit',
    loadChildren: () =>
      import(
        './pages/users/household/household-edit/household-edit.module'
      ).then((m) => m.HouseholdEditPageModule),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'household-history',
    loadChildren: () =>
      import(
        './pages/users/household/household-history/household-history.module'
      ).then((m) => m.HouseholdHistoryPageModule),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'household-pending',
    loadChildren: () =>
      import(
        './pages/users/household/household-pending/household-pending.module'
      ).then((m) => m.HouseholdPendingPageModule),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'household-bins',
    loadChildren: () =>
      import(
        './pages/users/household/household-bins/household-bins.module'
      ).then((m) => m.HouseholdBinsPageModule),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'depot',
    loadChildren: () =>
      import('./pages/users/depot/depot.module').then((m) => m.DepotPageModule),
    canActivate: [DepotGuard],
  },
  {
    path: 'depot-home',
    loadChildren: () =>
      import('./pages/users/depot-user/depot-home/depot-home.module').then(
        (m) => m.DepotHomePageModule
      ),
    canActivate: [DepotGuard],
  },
  {
    path: 'depot-pending',
    loadChildren: () =>
      import(
        './pages/users/depot-user/depot-pending/depot-pending.module'
      ).then((m) => m.DepotPendingPageModule),
    canActivate: [DepotGuard],
  },
  {
    path: 'depot-information',
    loadChildren: () =>
      import(
        './pages/users/depot-user/depot-information/depot-information.module'
      ).then((m) => m.DepotInformationPageModule),
    canActivate: [DepotGuard],
  },
  {
    path: 'depot-enterprises',
    loadChildren: () =>
      import(
        './pages/users/depot-user/depot-enterprises/depot-enterprises.module'
      ).then((m) => m.DepotEnterprisesPageModule),
    canActivate: [DepotGuard],
  },
  {
    path: 'admin-home',
    loadChildren: () =>
      import('./pages/users/system-admin/admin-home/admin-home.module').then(
        (m) => m.AdminHomePageModule
      ),
    canActivate: [AdminGuard],
  },
  {
    path: 'admin-mr-bins',
    loadChildren: () =>
      import(
        './pages/users/system-admin/admin-mr-bins/admin-mr-bins.module'
      ).then((m) => m.AdminMrBinsPageModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'admin-houses',
    loadChildren: () =>
      import(
        './pages/users/system-admin/admin-houses/admin-houses.module'
      ).then((m) => m.AdminHousesPageModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'admin-depots',
    loadChildren: () =>
      import(
        './pages/users/system-admin/admin-depots/admin-depots.module'
      ).then((m) => m.AdminDepotsPageModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'admin-edit',
    loadChildren: () =>
      import('./pages/users/system-admin/admin-edit/admin-edit.module').then(
        (m) => m.AdminEditPageModule
      ),
    canActivate: [AdminGuard],
  },
  {
    path: 'mr-bin-edit',
    loadChildren: () =>
      import('./pages/users/mr-bin/mr-bin-edit/mr-bin-edit.module').then(
        (m) => m.MrBinEditPageModule
      ),
    canActivate: [MrBinGuard],
  },
  {
    path: 'pickup-map',
    loadChildren: () =>
      import('./pages/users/mr-bin/pickup-map/pickup-map.module').then(
        (m) => m.PickupMapPageModule
      ),
    canActivate: [MrBinGuard],
  },
  {
    path: 'user-cashier',
    loadChildren: () =>
      import('./pages/users/household/user-cashier/user-cashier.module').then(
        (m) => m.UserCashierPageModule
      ),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'user-withdraw',
    loadChildren: () =>
      import('./pages/users/household/user-withdraw/user-withdraw.module').then(
        (m) => m.UserWithdrawPageModule
      ),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'user-withdrawal-hist',
    loadChildren: () =>
      import(
        './pages/users/household/user-withdrawal-hist/user-withdrawal-hist.module'
      ).then((m) => m.UserWithdrawalHistPageModule),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'admin-payments',
    loadChildren: () =>
      import(
        './pages/users/system-admin/admin-payments/admin-payments.module'
      ).then((m) => m.AdminPaymentsPageModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'location',
    loadChildren: () =>
      import('./pages/location/location.module').then(
        (m) => m.LocationPageModule
      ),
  },
  {
    path: 'household-tracker',
    loadChildren: () =>
      import('./pages/users/household/tracker/tracker.module').then(
        (m) => m.TrackerPageModule
      ),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'pay',
    loadChildren: () =>
      import('./pages/users/depot-user/pay/pay.module').then(
        (m) => m.PayPageModule
      ),
    canActivate: [DepotGuard],
  },
  {
    path: 'mr-bin-wallet',
    loadChildren: () =>
      import('./pages/users/mr-bin/wallet/wallet.module').then(
        (m) => m.WalletPageModule
      ),
    canActivate: [MrBinGuard],
  },
  {
    path: 'depot-wallet',
    loadChildren: () =>
      import('./pages/users/depot-user/wallet/wallet.module').then(
        (m) => m.WalletPageModule
      ),
    canActivate: [DepotGuard],
  },
  {
    path: 'depot-withdraw',
    loadChildren: () =>
      import(
        './pages/users/depot-user/depot-withdraw/depot-withdraw.module'
      ).then((m) => m.DepotWithdrawPageModule),
    canActivate: [DepotGuard],
  },
  {
    path: 'depot-recharge',
    loadChildren: () =>
      import(
        './pages/users/depot-user/depot-recharge/depot-recharge.module'
      ).then((m) => m.DepotRechargePageModule),
    canActivate: [DepotGuard],
  },
  {
    path: 'admin-recharge',
    loadChildren: () =>
      import(
        './pages/users/system-admin/admin-recharge/admin-recharge.module'
      ).then((m) => m.AdminRechargePageModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'admin-waste',
    loadChildren: () =>
      import('./pages/users/system-admin/admin-waste/admin-waste.module').then(
        (m) => m.AdminWastePageModule
      ),
    canActivate: [AdminGuard],
  },
  {
    path: 'admin-wallet',
    loadChildren: () =>
      import(
        './pages/users/system-admin/admin-wallet/admin-wallet.module'
      ).then((m) => m.AdminWalletPageModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'user-transactions',
    loadChildren: () =>
      import(
        './pages/users/household/user-transactions/user-transactions.module'
      ).then((m) => m.UserTransactionsPageModule),
    canActivate: [HouseholdGuard],
  },
  {
    path: 'mr-bin-transactions',
    loadChildren: () =>
      import(
        './pages/users/mr-bin/mr-bin-transactions/mr-bin-transactions.module'
      ).then((m) => m.MrBinTransactionsPageModule),
    canActivate: [MrBinGuard],
  },
  {
    path: 'admin-transactions',
    loadChildren: () =>
      import(
        './pages/users/system-admin/admin-transactions/admin-transactions.module'
      ).then((m) => m.AdminTransactionsPageModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'mr-bin-withdraw',
    loadChildren: () =>
      import(
        './pages/users/mr-bin/mr-bin-withdraw/mr-bin-withdraw.module'
      ).then((m) => m.MrBinWithdrawPageModule),
    canActivate: [MrBinGuard],
  },
  {
    path: 'admin-login',
    loadChildren: () =>
      import('./pages/admin-login/admin-login.module').then(
        (m) => m.AdminLoginPageModule
      ),
  },
  {
    path: 'depot-history',
    loadChildren: () =>
      import(
        './pages/users/depot-user/depot-history/depot-history.module'
      ).then((m) => m.DepotHistoryPageModule),
    canActivate: [DepotGuard],
  },
  {
    path: 'admin-completed-waste',
    loadChildren: () =>
      import(
        './pages/users/system-admin/admin-completed-waste/admin-completed-waste.module'
      ).then((m) => m.AdminCompletedWastePageModule),
    canActivate: [AdminGuard],
  },
  {
    path: 'policy',
    loadChildren: () =>
      import('./pages/policy/policy.module').then((m) => m.PolicyPageModule),
  },
  {
    path: 'delete-account',
    loadChildren: () =>
      import('./pages/delete-account/delete-account.module').then(
        (m) => m.DeleteAccountModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
